import { Link } from "react-router-dom";
import AnimatedGlobe from "./AnimatedGlobe";
import BackgroundEffects from "./BackgroundEffects";
import "./home.css";

const AVATARS = [
  "/images/user1.jpg",
  "/images/user2.jpg",
  "/images/user3.jpg",
];

export default function Hero() {
  const handleStartInvesting = (e) => {
    const encryptedData = localStorage.getItem(
      process.env.REACT_APP_LOGIN_DATA_STORE
    );
    if (!encryptedData) {
      e.preventDefault();
      window.location.href = "https://gpsfinvest.investwell.app/app/#/login";
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  };

  return (
    <section className="gps-hero">
      <BackgroundEffects />

      <div className="gps-hero-inner">
        <div className="gps-hero-content">
          <p className="gps-hero-eyebrow">SMART INVESTMENTS. GLOBAL IMPACT.</p>

          <h1 className="gps-hero-title">
            Smart Investments.{" "}
            <span className="highlight">Global Opportunities.</span> Stronger
            Future.
          </h1>

          <p className="gps-hero-desc">
            Global Portfolio Solutions empowers you to grow wealth through
            diversified investment strategies, expert guidance, and disciplined
            risk management.
          </p>

          <div className="gps-hero-ctas">
            <Link
              to="/clientmutualfunds"
              className="gps-hero-cta-primary"
              onClick={handleStartInvesting}
            >
              Start Investing
              <span aria-hidden="true">→</span>
            </Link>
            <Link
              to="/mutual-fund"
              className="gps-hero-cta-secondary"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              Explore Solutions
            </Link>
          </div>

          {/* <div className="gps-hero-trust">
            <div className="gps-hero-avatars">
              {AVATARS.map((src, i) => (
                <img key={i} src={src} alt="" />
              ))}
            </div>
            <p className="gps-hero-trust-text">
              Trusted by <strong>10,000+</strong>
              <br />
              Investors Worldwide
            </p>
          </div> */}
        </div>

        <div className="gps-hero-visual">
          <AnimatedGlobe />
        </div>
      </div>
    </section>
  );
}
